<template>
    <div>

        <va-page-header>

            <div slot="title">
                <span>{{ _('Meta Form') }}</span>
            </div>

            <div slot="actions">
                <va-button
                    @click.native="navigate({name: 'formBuilder', params: {id: 'new'}, query: { workspace: selectedSection }})"
                    style="position: absolute; right: 22px; top: 35px;" type="primary" size="lg">
                    {{ _('NEW') }}
                    {{ _(selectedSection.toUpperCase().substring(0, selectedSection.length - 1)) }}
                    {{ _('META FORM') }}</va-button>
            </div>

        </va-page-header>

        <va-row :gutter="12">
            <va-column :lg="12" :md="12" :sm="12">
                <va-tabs @changed="selectSection" :cache-lifetime="10" style="min-height:680px !important;">

                    <va-tab :name="_('Article')">
                        <article-meta-forms />
                    </va-tab>

                </va-tabs>
            </va-column>
        </va-row>

    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    // import ArticleMetaForms from "../articles/ArticleMetaForms.vue"
    // import FileMetaForms from "../files/FileMetaForms.vue"
    // import MapMetaForms from "../maps/MapMetaForms.vue"

    export default {

        components: {
            // ArticleMetaForms,
            // FileMetaForms,
            // MapMetaForms
        },

        data() {
            return {
                parentRoute: '',
                selectedSection: ''
            };
        },

        computed: {
            ...mapGetters(['user', 'getUserClassRoles']),
        },

        methods: {

            selectSection(e) {
                if (e.tab.header == 'Article' || e.tab.header == 'مقاله') this.selectedSection = "articles"
                else if (e.tab.header == 'File' || e.tab.header == 'دوتنه') this.selectedSection = "files"
                else this.selectedSection = "maps"
                // this.selectedSection = e.tab.header.toLowerCase() + 's'
            },

            navigate(to) {
                this.$router.push(to);
            },

            getParentRoute() {
                this.parentRoute = this.$route.matched[0].name
            }
        },
        async mounted() {
            this.getParentRoute()
        }
    };
</script>

<style>
    .actions_btn:hover {
        color: black !important
    }
</style>